import { useEffect, useRef, useState } from 'react';
import * as esbuild from 'esbuild-wasm';
import { useUI } from '../contexts';

export function useEsbuild() {
  // Get UI state from context
  const { setGlobalError } = useUI();
  const [esbuildReady, setEsbuildReady] = useState(false);
  const esbuildInitRef = useRef(false);

  useEffect(() => {
    if (esbuildReady || esbuildInitRef.current) return;
    esbuildInitRef.current = true;
    const init = async () => {
      try {
        await esbuild.initialize({ wasmURL: '/esbuild.wasm', worker: true });
        setEsbuildReady(true);
      } catch (error) {
        esbuildInitRef.current = false;
        console.error('esbuild init error', error);
        setGlobalError('esbuild başlatılamadı');
      }
    };
    init();
  }, [esbuildReady, setGlobalError]);

  return { esbuildReady };
}
